export default (value, splitter = ' ') => {
    let result = { left: "0px", top: "0px", bottom: "0px", right: "0px" };
    if (!value || value.length == 0) {
        return result;
    }
    value = value.trim();
    let splittedValues = value.split(splitter);
    if (splittedValues.length == 1) {
        result.left = result.top = result.bottom = result.right = splittedValues[0].trim();
    } else if (splittedValues.length == 2) {
        result.top = result.bottom = splittedValues[0];
        result.left = result.right = splittedValues[1];
    } else if (splittedValues.length == 3) {
        result.top = splittedValues[0];
        result.left = result.right = splittedValues[1];
        result.bottom = splittedValues[2];
    } else if (splittedValues.length == 4) {
        result.top = splittedValues[0];
        result.right = splittedValues[1];
        result.bottom = splittedValues[2];
        result.left = splittedValues[3];
    }
    return result;
}